import { useEffect } from 'react';

import { TFunction } from '@mint-lib/i18n';
import { useAtom } from 'jotai';

import { getUserCurrency } from '../api/getUserCurrency/index.js';
import { userCurrencyStore } from '../store/userCurrencyStore.js';

export function useUserCurrencyState() {
  return useAtom(userCurrencyStore);
}

export const useFetchUserCurrency = (t: TFunction) => {
  const [, setUserCurrencyState] = useUserCurrencyState();

  useEffect(() => {
    getUserCurrency(t).then((data) => setUserCurrencyState(data));
  }, []);
};
